const mapCarolineContentAccess = require('./mapCarolineContentAccess');
const ACCESS = Object.freeze(mapCarolineContentAccess());

const useCarolineContentAccess = () => {
    return ACCESS;
};

module.exports = useCarolineContentAccess;
